export enum SectionStatus {
  DISABLED = 'disabled',
  HIDDEN = 'hidden',
  VISIBLE = 'visible'
}